var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import CustomSelect from '../../Custom/Select/CustomSelect';
const AlmeDropdown = (_a) => {
    var { responseAction, responseRevision, onChange, value, disabled } = _a, props = __rest(_a, ["responseAction", "responseRevision", "onChange", "value", "disabled"]);
    const [options] = useState(() => responseAction.Values.map(val => ({ label: val.DisplayLabel, value: typeof val.SubmitValue === 'number' ? `${val.SubmitValue}` : val.SubmitValue })));
    const [defaultOption] = useState(() => options.find(o => o.value === (typeof value === 'string' ? value : `${value}`)));
    const id = `${responseRevision}-AlmeDropdown`;
    const htmlProps = Object.assign({ 'aria-label': responseAction.TitleText }, props);
    const handleChange = (option) => {
        onChange({ value: option.value, valid: true });
    };
    return (React.createElement(CustomSelect, Object.assign({ name: id, id: id, onChange: handleChange, placeholder: responseAction.TitleText, options: options, defaultOption: defaultOption, isDisabled: disabled, rightIconOpen: React.createElement(FontAwesomeIcon, { id: `${id}-trigger-chevron-up-icon`, icon: ['far', 'chevron-up'] }), rightIconClosed: React.createElement(FontAwesomeIcon, { id: `${id}-trigger-chevron-down-icon`, icon: ['far', 'chevron-down'] }), placement: "TOP" }, htmlProps)));
};
export default AlmeDropdown;
